export default __webpack_public_path__ + "static/media/Matting.fd733ad7.png";